import { createContext, useContext, useEffect, useState } from "react";
import homepage_bg from "assets/pag/homepage_bg.pag";
// import transfer from "assets/pag/transfer.pag";
const PagContext = createContext({});

export const PagProvider = ({ children }) => {
  const [pag, setPag] = useState();
  const [homepagePag, setHomepagePag] = useState();
  // const [transferPag, setTransferPag] = useState();
  const [touristMapPag, setTouristMapPag] = useState();
  const [pagFail, setPagFail] = useState(false);

  useEffect(() => {
    async function init() {
      try {
        const touristFileUrl =
          window.$$device_type === 0
            ? await import("../../assets/pag/tourist_map_2x.pag")
            : await import("../../assets/pag/tourist_map_1x.pag");

        const touristMap = touristFileUrl.default;
        const [pag, ...files] = await Promise.all([
          window.libpag.PAGInit({
            locateFile: () =>
              "https://gimg2.gateimg.com/libpag/1692865164533055096libpag.wasm",
          }),
          fetch(homepage_bg),
          // fetch(transfer),
          fetch(touristMap),
        ]);

        // const fns = [setHomepagePag, setTransferPag, setTouristMapPag];
        const fns = [setHomepagePag, setTouristMapPag];
        setPag(pag);
        // throw "";
        for (let i = 0; i < files.length; i++) {
          const file = files[i];
          const buffer = await file.arrayBuffer();

          const pagFile = await pag.PAGFile.load(buffer);
          fns[i](pagFile);
        }
      } catch (e) {
        // message({
        //   type: "noIcon",
        //   content: "pag init failed!",
        //   isHomePage: true,
        // });
        setPagFail(true);
        console.log("pag init failed: ", e);
      }
    }
    init();
  }, []);

  return (
    <PagContext.Provider
      value={{
        pag,
        homepagePag,
        // transferPag,
        touristMapPag,
        pagFail,
        setPagFail,
      }}
    >
      {children}
    </PagContext.Provider>
  );
};

export const usePag = () => {
  const pag = useContext(PagContext);
  return pag;
};
